import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Stack, Text, TextInput, Textarea } from "@mantine/core";
import { AppModal } from "../../shared/AppModal";
import { useForm, yupResolver } from "@mantine/form";
import { useEffect } from "react";
import { useGetSimpleEmailTemplateQuery, useUpdatePriorityAttributeAndSendSimpleEmailMutation, useUpdatePriorityAttributeMutation } from "../../graphql/graphql";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
import { SimpleEmailTemplateInitialValues, SimpleEmailTemplateSchema } from "../simple-email-template/SimpleEmailTemplate.validation";
export const PriorityStatusSimpleEmailModal = ({ opened, close, priorityAttributeId, priorityStatus, onStatusChanged }) => {
    const [{ data, fetching }] = useGetSimpleEmailTemplateQuery({
        pause: !opened || !priorityStatus.simpleEmailTemplateId,
        variables: {
            simpleEmailTemplateId: priorityStatus.simpleEmailTemplateId ?? ""
        },
        requestPolicy: "network-only"
    });
    const [{ fetching: updateFetching }, updatePriorityAttribute] = useUpdatePriorityAttributeMutation();
    const [{ fetching: sendFetching }, updatePriorityAttributeAndSendSimpleEmail] = useUpdatePriorityAttributeAndSendSimpleEmailMutation();
    const form = useForm({
        mode: "controlled",
        initialValues: SimpleEmailTemplateInitialValues,
        validate: yupResolver(SimpleEmailTemplateSchema)
    });
    useEffect(() => {
        if (!opened)
            return;
        const template = data?.simpleEmailTemplates?.simpleEmailTemplate;
        if (template) {
            form.setValues({
                subject: template.subject ?? "",
                body: template.body ?? ""
            });
            form.resetDirty();
        }
    }, [opened, data?.simpleEmailTemplates?.simpleEmailTemplate]);
    const handleClose = () => {
        close();
        form.reset();
    };
    const handleStatusOnly = async () => {
        try {
            await updatePriorityAttribute({
                priorityAttributeId,
                priorityStatusId: priorityStatus.priorityStatusId
            });
            onStatusChanged(priorityStatus);
            showSuccessNotification("Referral stage updated.");
            handleClose();
        }
        catch (error) {
            console.error(error);
            showErrorNotification();
        }
    };
    const handleSendEmail = async () => {
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        try {
            await updatePriorityAttributeAndSendSimpleEmail({
                priorityAttributeId,
                priorityStatusId: priorityStatus.priorityStatusId,
                subject: form.values.subject,
                body: form.values.body
            });
            onStatusChanged(priorityStatus);
            showSuccessNotification("Referral stage updated and email sent.");
            handleClose();
        }
        catch (error) {
            console.error(error);
            showErrorNotification();
        }
    };
    return (_jsxs(AppModal, { title: `Send ${priorityStatus.name} Email`, opened: opened, onClose: handleClose, size: "lg", children: [_jsxs(Stack, { children: [_jsx(Text, { variant: "body", c: "dimmed", children: "This referral stage has an email template attached. You can review it before sending." }), _jsx(TextInput, { "data-autofocus": true, required: true, label: "Subject", placeholder: "Subject", ...form.getInputProps("subject") }), _jsx(Textarea, { required: true, label: "Body", autosize: true, minRows: 10, maxRows: 18, styles: { input: { whiteSpace: "pre-wrap" } }, ...form.getInputProps("body") })] }), _jsxs(Flex, { justify: "space-between", mt: "lg", gap: "sm", wrap: "wrap", children: [_jsx(Button, { variant: "outline", color: "gray", onClick: handleClose, children: "Cancel" }), _jsxs(Flex, { gap: "sm", wrap: "wrap", justify: "flex-end", children: [_jsx(Button, { variant: "outline", onClick: handleStatusOnly, loading: updateFetching, disabled: fetching || sendFetching, children: "Change Status" }), _jsx(Button, { variant: "filled", onClick: handleSendEmail, loading: sendFetching, disabled: fetching || updateFetching, children: "Send Email" })] })] })] }));
};
